import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";
import { OrderType } from "types/Order/OrderType";

import {
  StyledSettingRow,
  StyledSettingsCard,
  StyledSettingsDescription,
  StyledSettingsHeader,
  StyledSettingSubtitle,
  StyledSettingTitle,
} from "../styled";

interface IDisplaySetting {
  field: string;
  title: string;
  subtitle: string;
  /** Treat an unset value as on, matching the patient page's own default. */
  defaultOn?: boolean;
}

export const displaySettings: IDisplaySetting[] = [
  {
    field: "physicianEstimate",
    title: "Physician estimate",
    subtitle: "Show the physician fee row in the account summary.",
  },
  {
    field: "facilityEstimate",
    title: "Facility estimate",
    subtitle: "Show the facility fee label and amount in the account summary.",
  },
  {
    field: "discountPercentTotal",
    title: "Show discount percent",
    subtitle: 'Display the "10% off" badge on the Pay Now price.',
    defaultOn: true,
  },
  {
    field: "discountExpires",
    title: "Discount expires",
    subtitle:
      "Show the note letting patients know the discount is time-limited.",
  },
];

export function DisplaySettingsCard({ orderType }: { orderType: OrderType }) {
  const { control } = useFormContext();

  return (
    <StyledSettingsCard>
      <StyledSettingsHeader>
        <i className="pi pi-sliders-h" />
        DISPLAY SETTINGS
      </StyledSettingsHeader>

      <StyledSettingsDescription>
        Turn sections on or off. When a setting is off, that section is
        completely hidden from the patient preview below.
      </StyledSettingsDescription>

      {displaySettings.map((setting) => (
        <StyledSettingRow key={setting.field}>
          <div>
            <StyledSettingTitle>{setting.title}</StyledSettingTitle>
            <StyledSettingSubtitle>{setting.subtitle}</StyledSettingSubtitle>
          </div>

          <Controller
            name={`${orderType}-${setting.field}`}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputSwitch
                inputId={`${orderType}-${setting.field}`}
                data-test-id={`${orderType}-${setting.field}-switch`}
                checked={
                  setting.defaultOn && value === undefined ? true : !!value
                }
                onChange={(event) => onChange(event.value)}
              />
            )}
          />
        </StyledSettingRow>
      ))}
    </StyledSettingsCard>
  );
}
